import { createReducer, on } from '@ngrx/store';
import { getEmbeddedResource, getUrl } from '@ngxp/rest';
import { loadRechtspflegerSuccessAction } from './rechtspfleger/rechtspfleger.actions';
import {
	loadUserSuccessAction,
	logInUserSuccessAction,
	logOutUserSuccessAction,
	unauthorizeUserAction,
} from './user.actions';
import { UserListLinkRel } from './user.linkrel';
import { UserListResource, UserResource } from './user.model';

export interface UserState {
	user: UserResource;
	rechtspfleger: UserListResource;
	users: {
		[userId: string]: UserResource;
	};
}

export const initialState: UserState = {
	user: undefined,
	rechtspfleger: null,
	users: null,
};

export const userReducer = createReducer(
	initialState,
	on(logInUserSuccessAction, (state: UserState, { user }): UserState => ({
		...state,
		user,
	})),
	on(logOutUserSuccessAction, (state: UserState): UserState => ({
		...state,
		user: undefined,
	})),
	on(unauthorizeUserAction, (state: UserState): UserState => ({
		...state,
		user: undefined,
	})),
	on(loadRechtspflegerSuccessAction, (state: UserState, { rechtspflegerList }): UserState => ({
		...state,
		rechtspfleger: rechtspflegerList,
		users: fillUsersMap(
			<UserResource[]>getEmbeddedResource(rechtspflegerList, UserListLinkRel.USER_LIST),
			state.users
		),
	})),
	on(loadUserSuccessAction, (state: UserState, { user }): UserState => ({
		...state,
		users: { ...state.users, [getUrl(user)]: user },
	}))
);

function fillUsersMap(
	users: UserResource[],
	existingData: { [userId: string]: UserResource }
): { [userId: string]: UserResource } {
	return users.reduce((prev, curr) => {
		return { ...prev, [getUrl(curr)]: curr };
	}, existingData);
}
